/* PavCon, LLC Proprietary.All rights reserved 2022 */
import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';

import CognitoService from '../services/cognito';
import { Injectable } from '@angular/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { environment } from 'src/environments/environment';
import { from } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Injectable()
export class HeaderInterceptor implements HttpInterceptor {
  excludedUrls = [];

  constructor(
    private localCognitoService: CognitoService,
    private ngxService: NgxUiLoaderService
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    const endPoint = environment.endpoint; //getEndpoint
    const excludedUrls = [
      `${endPoint}common/majcoms`,
      `${endPoint}common/settingVersion`,
      `${endPoint}auth/getBases`,
      `${endPoint}auth/checkEmail`,
      `${endPoint}auth/disabledCheck`,
      `${endPoint}auth/checkUsername`,
      `${endPoint}auth/hashStore`,
      `${endPoint}training-videos/unauth`,
      `https://s3.us-gov-west-1.amazonaws.com/`,
      `https://cristil-clean-tempdata-dev`,
      `https://cristil-clean-tempdata-demo`,
      `https://cristil-clean-tempdata-qa`,
      `https://cristil-clean-tempdata-preprod`,
      `https://cristil-clean-tempdata-prod`,
    ]; //Public api requests should go here
    let authReq: any;
    if (excludedUrls.some((x) => req.url.includes(x))) {
      authReq = req.clone();
      return next.handle(authReq);
    } else {
      return from(this.localCognitoService.getCurrentIdToken()).pipe(
        switchMap((token) => {
          authReq = req.clone({ setHeaders: { Authorization: 'Bearer ' + token } });
          // this.ngxService.start();
          this.ngxService.startBackground();
          //  this.ngxService.startLoader('features-loader');
          return next.handle(authReq);
        })
      );
    }
  }
}
/*Distribution Statement B. Distribution authorized to U.S. Government agencies only.PavCon, LLC Proprietary.All rights reserved.
  2020 WARNING: this file may contain export controlled information.*/
